function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 22H22C23.1045 22 24 21.1046 24 20V8C24 6.89543 23.1045 6 22 6H11.5L11.75 8H22V20H11.2579L9.5 22Z",
  fill: "#352D42"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 18L6.62127 20.4851C6.84385 21.3754 7.64382 22 8.56155 22H9.5L13 18H10.3469H8.59H8.06771H6Z",
  fill: "#352D42"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6 18L6.62127 20.4851C6.84385 21.3754 7.64382 22 8.56155 22H9.5L13 18H10.3469H8.59H8.06771H6Z",
  fill: "black",
  fillOpacity: 0.3
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6133 11.8398C15.056 11.6133 15.5208 11.5 16.0078 11.5C16.4427 11.5 16.7852 11.6146 17.0352 11.8438C17.2878 12.0729 17.4141 12.3737 17.4141 12.7461C17.4141 13.1549 17.2539 13.4844 16.9336 13.7344C17.0352 13.7734 17.1771 13.793 17.3594 13.793C17.5495 13.793 17.7266 13.7539 17.8906 13.6758C18.0573 13.5977 18.224 13.4727 18.3906 13.3008V12.4648H17.8828V11.5586H20.2188V12.4648H19.4648V16.5586H18.3906V14.3281C18.1536 14.4661 17.8477 14.5469 17.4727 14.5703C17.4987 14.6797 17.5117 14.7786 17.5117 14.8672C17.5117 15.2552 17.3854 15.5547 17.1328 15.7656C16.8828 15.974 16.526 16.0781 16.0625 16.0781C15.7161 16.0781 15.4023 16.0143 15.1211 15.8867C14.8424 15.7591 14.5677 15.5299 14.2969 15.1992C14.026 14.8659 13.7604 14.3906 13.5 13.7734L14.4219 13.4219C14.6484 14.0104 14.888 14.4505 15.1406 14.7422C15.3958 15.0312 15.6758 15.1758 15.9805 15.1758C16.293 15.1758 16.4492 15.0221 16.4492 14.7148C16.4492 14.4622 16.3633 14.2435 16.1914 14.0586C16.0117 14.0977 15.8112 14.1198 15.5898 14.125L15.5469 13.2812C15.8255 13.2656 16.0299 13.2201 16.1602 13.1445C16.2904 13.069 16.3555 12.944 16.3555 12.7695C16.3555 12.5091 16.181 12.3789 15.832 12.3789C15.5612 12.3789 15.2539 12.4661 14.9102 12.6406L14.6133 11.8398Z",
  fill: "#352D42"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.23444 2C10.2431 2 11.0939 2.75107 11.219 3.75193L13 18H2C0.89543 18 0 17.1046 0 16V4C0 2.89543 0.895431 2 2 2H9.23444ZM7.25732 11.5774L7.60042 13H9.06485L7.14854 7H5.40795L3.5 13H4.9728L5.32427 11.5774H7.25732ZM6.47071 8.75732C6.50418 8.88563 6.53766 9.00837 6.57113 9.12552L6.96444 10.5146H5.62552L6.01046 9.12552C6.04393 9.01395 6.07462 8.894 6.10251 8.76569C6.13598 8.63738 6.16946 8.50349 6.20293 8.36402C6.2364 8.21897 6.2643 8.07392 6.28661 7.92887C6.3145 8.07392 6.3424 8.21618 6.37029 8.35565C6.40377 8.49512 6.43724 8.62901 6.47071 8.75732Z",
  fill: "#352D42"
});
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language_icon.94de5e3cc09193593870ec211a6e0d8a.svg";
export { ForwardRef as ReactComponent };